/*
 * @Description: 公共接口 设备相关
 * @Author: sunxiaodong
 * @Date: 2020-07-28 15:54:45
 * @LastEditors: lidan
 * @LastEditTime: 2021-01-05 16:30:27
 */

import http from "e6-base-core/axios/config";
import { e6ModuleOrderWaybillProcessApi } from "@/config/api";
const {
  host,
  // E6_MS_TMS_E6YUN_BASE_WEB,
  E6_MS_TMS_BUSI_WEB
} = e6ModuleOrderWaybillProcessApi;

/************************设备相关接口*************************/
//根据车辆id查询设备信息
export function getMonitorEpuipList(params) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/equip/findEquipByCarId`,
    method: "get",
    params
  });
}
// 设备类型
export function getEquipTypeList() {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/equip/findEquipTypeList`,
    method: "get"
  });
}
// 设备
export function getEquipList(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/equip/findEquipByType`,
    method: "post",
    data
  });
}
